import {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import { NavigationList, DropdownContainer } from './styles';
import { API, Lang } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { InfoItem } from './components/InfoItem';
import { Dropdown, DropdownListItem } from '@brg/ui';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import { MagicBoxRow } from '../toolsStyles';
import { DropdownBodyWrapper } from '../ProjectAnchorNavigate';
import styled from 'styled-components';

const HOMEWORK_SIGN = 'Домашняя работа';

const FullWidthDiv = styled.div`
    padding-right: 16px;
    > div {
        width: 100%;
    }

    .dropdown-button{
        position: relative;
        z-index: 999999;
    }
`;


export type JustHomeWorkT = {
    justHomeWork: boolean
}
type DataInfoT = {
    title: string;
    data: any;
}

type PropsT = {
    info?: DataInfoT[];
    onHmVisible: boolean;
    anchors: Record<string, string>;
    onSortClick: (id: string) => void;
    currentPost: string | null;
    visibleFilter: boolean;
    hasHeader?: boolean;
}

export const CourseInfoList: FC<PropsT> = ({ info, anchors, onHmVisible, currentPost, visibleFilter, onSortClick, hasHeader = false }) => {
    const { t, i18n } = useTranslation();
    const navRef = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState(false);
    const [activeHash, setActiveHash] = useState(() => window.location.hash.replace('#', ''));

const handleClose = useCallback((ev: any) => {
    const target = ev.target as Element;

    if (target && typeof target.className === 'string' && target.className?.includes('baseVal')) {
        return;
    }

    if (navRef.current && navRef.current.contains(target)) {
        return;
    }

    setOpen(false);
}, []);

    useEffect(() => {
        window.addEventListener('click', handleClose)
        return () => {
          window.removeEventListener('click', handleClose)
        }
      }, [handleClose])

    useEffect(() => {
        const updateHash = () => setActiveHash(window.location.hash.replace('#', ''));
        window.addEventListener('hashchange', updateHash);
        window.addEventListener('popstate', updateHash);
        return () => {
            window.removeEventListener('hashchange', updateHash);
            window.removeEventListener('popstate', updateHash);
        };
    }, []);

    const isEmpty = useMemo(() => {

        if (!info || info?.length === 0) return true;
        if (info?.find(i => i?.title === "theme_structure")?.data?.length === 0) return true;
        return false;

    }, [info])

    if (isEmpty) return null;

    return (
        <NavigationList ref={navRef} hasHeader={hasHeader}>
            <DropdownContainer visible={open} className='dropdown-container'>
                <DropdownBodyWrapper visible={open}>
                {info?.length && info?.map((i) => {
                const title = i.title;
                const data = (visibleFilter && info.some((i) => i.data?.some((block: any) => block?.isHomework))) ? [{ type: 'checkbox'}, ...i.data] : i.data;
                let counter = 0;

                return (
                    // @ts-ignore
                    <FullWidthDiv className='sdsdsdsd'>
                        <Dropdown visibility={open} maxWidth={280 - 16} maxHeight={350} hideArrow target={<ArrowTopIconWithText onClick={() => {
                            setOpen(!open)
                        }} fill={'#909090'} shrimpIcon text={t(`project_edit.lms.${title}`)}/>}>

                            {data?.length && data?.map((i: any, idx: number) => {
                                const lgId = i?.longreadId;
                                const hasHomeWork = i.isHomework;
                                const isExam = i?.isExam;
                                const isCheckbox = i.type === 'checkbox';
                                const name = Lang(isExam ? i?.title : i?.name, i18n.language);
                                //@ts-ignore
                                const anchor = anchors[lgId]?.find((i) => {
                                    //Пока не придумал по какому признаку их еще разделять
                                    return (i.name || i.text) === ( hasHomeWork ? HOMEWORK_SIGN : name)
                                });
                                
                                if (!anchor?.postId || anchor?.postId === 'undefined') {
                                    return null; 
                                }
                                
                                if (hasHomeWork && anchor?.postId === `homework-header-${lgId}` && !anchor?.postId.includes('homework-header-')) {
                                    return null; 
                                }
                                
                                const link = window.location.pathname + '#' + anchor?.postId;
                                const isActive = activeHash === anchor?.postId;
                                if (isExam) {
                                    return (
                                        <InfoItem
                                            key={i?.id + idx}
                                            showOrderNumber={!onHmVisible}
                                            name={name}
                                            order={counter}
                                            href={link}
                                            isActive={isActive}
                                            isExam
                                            postId={anchor?.postId}
                                        />
                                    )
                                }

                                if (!hasHomeWork || !onHmVisible) counter = counter + 1

                            return (
                                    <InfoItem 
                                        key={i?.id + idx}
                                        showOrderNumber={!onHmVisible}
                                        name={name}
                                        order={counter}
                                        href={link}
                                        isActive={isActive} 
                                        isHomeWork={hasHomeWork}
                                        postId={anchor?.postId}
                                        homeworkStatus={hasHomeWork ? i?.homeworkStatus : undefined}
                                    />
                                )
                            })}
                        </Dropdown>
                    </FullWidthDiv>
                )
            })}
                </DropdownBodyWrapper>

            </DropdownContainer>
        </NavigationList>
    )
}
import {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import { NavigationList, DropdownContainer } from './styles';
import { API, Lang } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { InfoItem } from './components/InfoItem';
import { Dropdown, DropdownListItem } from '@brg/ui';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import { MagicBoxRow } from '../toolsStyles';
import { DropdownBodyWrapper } from '../ProjectAnchorNavigate';
import styled from 'styled-components';

const HOMEWORK_SIGN = 'Домашняя работа';

const FullWidthDiv = styled.div`
    padding-right: 16px;
    > div {
        width: 100%;
    }

    .dropdown-button{
        position: relative;
        z-index: 999999;
    }
`;


export type JustHomeWorkT = {
    justHomeWork: boolean
}
type DataInfoT = {
    title: string;
    data: any;
}

type PropsT = {
    info?: DataInfoT[];
    onHmVisible: boolean;
    anchors: Record<string, string>;
    onSortClick: (id: string) => void;
    currentPost: string | null;
    visibleFilter: boolean;
    hasHeader?: boolean;
}

export const CourseInfoList: FC<PropsT> = ({ info, anchors, onHmVisible, currentPost, visibleFilter, onSortClick, hasHeader = false }) => {
    const { t, i18n } = useTranslation();
    const navRef = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState(false);
    const [activeHash, setActiveHash] = useState(() => window.location.hash.replace('#', ''));

const handleClose = useCallback((ev: any) => {
    const target = ev.target as Element;

    if (target && typeof target.className === 'string' && target.className?.includes('baseVal')) {
        return;
    }

    if (navRef.current && navRef.current.contains(target)) {
        return;
    }

    setOpen(false);
}, []);

    useEffect(() => {
        window.addEventListener('click', handleClose)
        return () => {
          window.removeEventListener('click', handleClose)
        }
      }, [handleClose])

    useEffect(() => {
        const updateHash = () => setActiveHash(window.location.hash.replace('#', ''));
        window.addEventListener('hashchange', updateHash);
        window.addEventListener('popstate', updateHash);
        return () => {
            window.removeEventListener('hashchange', updateHash);
            window.removeEventListener('popstate', updateHash);
        };
    }, []);

    const isEmpty = useMemo(() => {

        if (!info || info?.length === 0) return true;
        if (info?.find(i => i?.title === "theme_structure")?.data?.length === 0) return true;
        return false;

    }, [info])

    if (isEmpty) return null;

    return (
        <NavigationList ref={navRef} hasHeader={hasHeader}>
            <DropdownContainer visible={open} className='dropdown-container'>
                <DropdownBodyWrapper visible={open}>
                {info?.length && info?.map((i) => {
                const title = i.title;
                const data = (visibleFilter && info.some((i) => i.data?.some((block: any) => block?.isHomework))) ? [{ type: 'checkbox'}, ...i.data] : i.data;
                let counter = 0;

                return (
                    // @ts-ignore
                    <FullWidthDiv className='sdsdsdsd'>
                        <Dropdown visibility={open} maxWidth={280 - 16} maxHeight={350} hideArrow target={<ArrowTopIconWithText onClick={() => {
                            setOpen(!open)
                        }} fill={'#909090'} shrimpIcon text={t(`project_edit.lms.${title}`)}/>}>

                            {data?.length && data?.map((i: any, idx: number) => {
                                const lgId = i?.longreadId;
                                const hasHomeWork = i.isHomework;
                                const isExam = i?.isExam;
                                const isCheckbox = i.type === 'checkbox';
                                const name = Lang(isExam ? i?.title : i?.name, i18n.language);
                                //@ts-ignore
                                const anchor = anchors[lgId]?.find((i) => {
                                    //Пока не придумал по какому признаку их еще разделять
                                    return (i.name || i.text) === ( hasHomeWork ? HOMEWORK_SIGN : name)
                                });
                                
                                if (!anchor?.postId || anchor?.postId === 'undefined') {
                                    return null; 
                                }
                                
                                if (hasHomeWork && anchor?.postId === `homework-header-${lgId}` && !anchor?.postId.includes('homework-header-')) {
                                    return null; 
                                }
                                
                                const link = window.location.pathname + '#' + anchor?.postId;
                                const isActive = activeHash === anchor?.postId;
                                if (isExam) {
                                    return (
                                        <InfoItem
                                            key={i?.id + idx}
                                            showOrderNumber={!onHmVisible}
                                            name={name}
                                            order={counter}
                                            href={link}
                                            isActive={isActive}
                                            isExam
                                            postId={anchor?.postId}
                                        />
                                    )
                                }

                                if (!hasHomeWork || !onHmVisible) counter = counter + 1

                            return (
                                    <InfoItem 
                                        key={i?.id + idx}
                                        showOrderNumber={!onHmVisible}
                                        name={name}
                                        order={counter}
                                        href={link}
                                        isActive={isActive} 
                                        isHomeWork={hasHomeWork}
                                        postId={anchor?.postId}
                                        homeworkStatus={hasHomeWork ? i?.homeworkStatus : undefined}
                                    />
                                )
                            })}
                        </Dropdown>
                    </FullWidthDiv>
                )
            })}
                </DropdownBodyWrapper>

            </DropdownContainer>
        </NavigationList>
    )
}
